export default __webpack_public_path__ + "static/media/mccTest.f573ef06.csv";